<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3">Sertifikasi</CCardHeader>
    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/finance/payment"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Payment Gateway</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/finance/keanggotaan"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >Keanggotaan</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/finance/sertifikasi"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          style="background-color: #486ba7;"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Sertifikasi</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/finance/pelatihan"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Pelatihan</router-link>
      </li>
    </ul>
    <!-- Data Sertifikasi ACPAphp -->
    <CCardBody class="mt-3">
      <h5 class="font-weight-bold">Sertifikasi ACPA</h5>
      <CCardHeader class="bg-primary text-white">Persyaratan Dokumen</CCardHeader>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <table class="table table-striped table-inverse">
            <thead class="thead-inverse">
              <tr>
                <th>No</th>
                <th>Nama Peserta</th>
                <th>Nama Ujian Yang Diikuti</th>
                <th>Biaya Ujian</th>
                <th>Di Transfer pada</th>
                <th>Bukti Transfer</th>
                <th>Status Verifikasi</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td scope="row">1</td>
                <td>Erna Surya Ningsih</td>
                <td></td>
                <td></td>
                <td>Kamis, 20 Januari 2020</td>
                <td>Kamis, 20 Januari 2020</td>
                <td>
                  <button type="button" class="btn btn-sm btn-success">Terverifikasi</button>
                </td>
                <td>
                  <button type="button" class="btn btn-sm btn-info" @click="myModal = true">Verifikasi</button>
                </td>
              </tr>
            </tbody>
          </table>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
    </CCardBody>
    <!-- End Data Sertifikasi ACPA -->
    <!-- Data Sertifikasi CPA -->
    <CCardBody class="mt-3">
      <h5 class="font-weight-bold">Sertifikasi CPA</h5>
      <CCardHeader class="bg-primary text-white">Persyaratan Dokumen</CCardHeader>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <table class="table table-striped table-inverse">
            <thead class="thead-inverse">
              <tr>
                <th>No</th>
                <th>Nama Peserta</th>
                <th>Nama Ujian Yang Diikuti</th>
                <th>Biaya Ujian</th>
                <th>Di Transfer pada</th>
                <th>Bukti Transfer</th>
                <th>Status Verifikasi</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td scope="row">1</td>
                <td>Erna Surya Ningsih</td>
                <td></td>
                <td></td>
                <td>Kamis, 20 Januari 2020</td>
                <td>Kamis, 20 Januari 2020</td>
                <td>
                  <button type="button" class="btn btn-sm btn-success">Terverifikasi</button>
                </td>
                <td>
                  <button type="button" class="btn btn-sm btn-info" @click="myModal = true">Verifikasi</button>
                </td>
              </tr>
            </tbody>
          </table>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
    </CCardBody>
    <!-- End Data Sertifikasi CPA -->
    <!-- Data Sertifikasi CTA -->
    <CCardBody class="mt-3">
      <h5 class="font-weight-bold">Sertifikasi CTA</h5>
      <CCardHeader class="bg-primary text-white">Persyaratan Dokumen</CCardHeader>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <table class="table table-striped table-inverse">
            <thead class="thead-inverse">
              <tr>
                <th>No</th>
                <th>Nama Peserta</th>
                <th>Nama Ujian Yang Diikuti</th>
                <th>Biaya Ujian</th>
                <th>Di Transfer pada</th>
                <th>Bukti Transfer</th>
                <th>Status Verifikasi</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td scope="row">1</td>
                <td>Erna Surya Ningsih</td>
                <td></td>
                <td></td>
                <td>Kamis, 20 Januari 2020</td>
                <td>Kamis, 20 Januari 2020</td>
                <td>
                  <button type="button" class="btn btn-sm btn-danger">Belum Terverifikasi</button>
                </td>
                <td>
                  <button type="button" class="btn btn-sm btn-info" @click="myModal = true">Verifikasi</button>
                </td>
              </tr>
            </tbody>
          </table>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Diverifikai Pada" />
            </CCol>
            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" class="custom-control-input" name="customRadio" id="aktif" />
                  <label class="custom-control-label" for="aktif">Terverifikasi</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                </div>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Persyaratan Dokumen</h6>          
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data Sertifikasi CTA -->
  </CCard>
</template>
<script>
const items = [
  {
    no: "1",
    kode: "HRG-1",
    jenis_ujian: "Sertifikasi",
    nama_ujian: "RPL Acpa Batch",
    jawaban: "Buruk",
    _status: 0
  },
  {
    no: "2",
    kode: "P-2",
    jenis_ujian: "Sertifikasi",
    nama_ujian: "RPL Acpa Batch",
    jawaban: "Buruk",
    _status: 0
  },
  {
    no: "3",
    kode: "P-3",
    jenis_ujian: "Sertifikasi",
    nama_ujian: "RPL Acpa Batch",
    jawaban: "Buruk",
    _status: 0
  },
  {
    no: "4",
    kode: "P-4",
    jenis_ujian: "Sertifikasi",
    nama_ujian: "RPL Acpa Batch",
    jawaban: "Buruk",
    _status: 0
  },
  {
    no: "5",
    kode: "P-5",
    jenis_ujian: "Sertifikasi",
    nama_ujian: "RPL Acpa Batch",
    jawaban: "Buruk",
    _status: 0
  }
];

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "kode",
    label: "Kode Kuesioner",
    sorter: true,
    filter: false
  },
  {
    key: "jenis_ujian",
    label: "Kode Pelatihan",
    sorter: true,
    filter: false
  },
  {
    key: "nama_ujian",
    label: "Nama Responden",
    sorter: true,
    filter: false
  },
  {
    key: "jawaban",
    label: "Jawaban",
    sorter: true,
    filter: false
  },  
  {
    key: "_status",
    _style: "text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:10%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Master RPL",
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  methods: {
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>